import type { Member } from 'app/scripts/models/member';
import { difference } from 'underscore';

export const isGuestOrganization = (
  modelType: string,
  idModel: string,
  me?: Member,
): boolean => {
  if (modelType !== 'Organization') return false;
  const idOrganizations = me && me.get('idOrganizations');
  const idBoardOrganizations =
    me?.boardList?.models
      ?.filter((board) => board.isOpen() && board.get('idOrganization'))
      .map((board) => board.get('idOrganization')) || [];
  const idGuestOrganizations = idOrganizations
    ? difference(idBoardOrganizations, idOrganizations)
    : idBoardOrganizations;
  return idGuestOrganizations.includes(idModel);
};
